import Coupon from 'types/Coupon';
import Plan from 'types/Plan';

export function isTrial(plan: Plan, coupon?: Coupon) {
  return ['alltrails_pro_annual_30_7trial', 'alltrails_pro_annual_36_7trial'].includes(plan.recurlyPlanCode) || coupon?.type === 'FreeTrialCoupon';
}

export function getPriceTotal(plan: Plan, coupon?: Coupon) {
  if (coupon && coupon.type !== 'FreeTrialCoupon') {
    // Recurly only allows integer based discount percentages but we really want 1/3 off when we say 33% or 34%
    const discountPercentage = coupon.discountPercentage === 33 || coupon.discountPercentage === 34 ? 100 / 3 : coupon.discountPercentage;

    // make sure we trunc so $29.99 * 50% off = $14.99 and not $14.995 rounded to $15
    return Math.trunc(Number(plan.priceTotal) * (100 - discountPercentage)) / 100;
  }

  return Number(plan.priceTotal);
}
